var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy16 = function SvgCopy16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.5 12.5H6V6h6.5v6.5Zm.3-8.1H5.6c-.66 0-1.2.54-1.2 1.2v7.2c0 .66.54 1.2 1.2 1.2h7.2c.66 0 1.2-.54 1.2-1.2V5.6c0-.66-.54-1.2-1.2-1.2ZM9.2 2.75A.75.75 0 0 0 8.45 2H3.2C2.54 2 2 2.54 2 3.2v5.25a.75.75 0 0 0 1.5 0V3.5h4.95a.75.75 0 0 0 .75-.75Z"
  })));
};
export default SvgCopy16;